import React, {useContext, useEffect, useState} from 'react';

import {AuthContext} from '../../context';
import {PageContainer, ServiceContainer, ServiceNotAvailable} from '../../components';
import {months, servicesName} from '../../utils';

const Service = ({location, history}) => {
  const currentMonth = new Date().getMonth();
  const {user} = useContext(AuthContext);
  const {service} = location.state;
  const [isAvailable, setiIsAvailable] = useState(false);
  const [serviceToDisplay, setServiceToDisplay] = useState();
  const [monthToDisplay, setMonthToDisplay] = useState();
  const [name, setName] = useState();

  const handleData = async () => {
    setiIsAvailable(false);
    const filteredService = user.company.services.find(
      (s) => s.service._id === service._id
    );
    if (filteredService) {
      setMonthToDisplay(
        filteredService.monthlyMonitoring.find((m) => m.month === months[currentMonth])
      );
      setName(
        servicesName.find(
          (s) => s.singular === filteredService.service.name.toLocaleLowerCase()
        )
      );
      setServiceToDisplay(filteredService);
      setiIsAvailable(true);
    }
  };

  useEffect(() => {
    handleData();
  }, [service]);

  return (
    <PageContainer
      title={service.name}
      role={user.infos.role}
      companyName={user.company.name}
      history={history}
    >
      {isAvailable ? (
        <ServiceContainer
          serviceToDisplay={serviceToDisplay}
          monthToDisplay={monthToDisplay}
          handleChange={setMonthToDisplay}
          name={name}
        />
      ) : (
        <ServiceNotAvailable />
      )}
    </PageContainer>
  );
};

export default Service;
